export default function TogglePasswordIcon({
    style,
    fill="#E8E8E8"
}){
    return <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="11" cy="3" rx="8" ry="3" fill="#83CFA4"/>
    <path d="M18.615 3.33203L20.9991 7.44441" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.7322 5.62207L14.4714 9.81774" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.268 5.6123L7.52881 9.81839" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.38414 3.33203L1 7.46524" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.01123 1C2.76029 3.16551 5.96691 5.90363 11.0059 5.90363C16.0449 5.90363 19.2515 3.16551 21.0005 1" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>   
}